import { ItemTypeCategory as GqlItemTypeCategory } from '@/graphql/generatedTypes';

export const ItemTypeCategories: readonly GqlItemTypeCategory[] =
  Object.values(GqlItemTypeCategory);

export type ItemTypeCategory = GqlItemTypeCategory;
export type ItemTypeCategoryWithContainer = ItemTypeCategory | 'CONTAINER';

export const ItemTypeCategoryOrder: Record<
  ItemTypeCategoryWithContainer,
  number
> = {
  CONTAINER: 0,
  [GqlItemTypeCategory.ContainerStation]: 1,
  [GqlItemTypeCategory.Asset]: 2,
  [GqlItemTypeCategory.StoreAsset]: 3,
};
